import { useFlag } from '@/feature/feature-flags'
import { MARKER_STATIONARY_COLOR, ObservatoryReplaySettings } from '@/feature/observatory'

export const useReplayConfig = (): ObservatoryReplaySettings =>
  useFlag<ObservatoryReplaySettings>('replayConfig', {
    route: {
      layers: [
        {
          colour: '#FFF',
          width: 15,
        },
        {
          colour: MARKER_STATIONARY_COLOR,
          width: 8,
        },
      ],
    },
    time: {
      defaultOption: '1hr',
      options: ['1hr', '4hr', '8hr', '24hr', '48hr'],
      granularity: '1m',
    },
  })
